import YwLoading from "./src/index.vue";

YwLoading.install = function (Vue) {
	Vue.component(YwLoading.name, YwLoading);
};

export default YwLoading;
